import React, { useCallback, useEffect, useState } from 'react'
import { Box, Container, IconButton, Typography } from '../imports/muiImport'
import { Helmet } from 'react-helmet-async'


import { Logo99, useLocation, useNavigate } from '../imports/generalImport';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import LoginPage from './LoginPage';
import SignupPage from './SignupPage';
import PasswordReset from './PasswordResetPage';


const MobileAuthLayout = () => {
    const [pageShow, setPageShow] = useState("/login");

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        setPageShow(location.pathname);
    }, [location]);

    const handleBack = useCallback(() => {
        navigate('/', { replace: true });
    }, []);

    return (
        <Container
            maxWidth="false"
            sx={{
                bgcolor: "#e6f9ff",
                minHeight: "100vh",
            }}
        >
            <Helmet>
                <title>{pageShow.slice(0)} -99gift.in</title>
                <meta property="og:title" content="Login -99gift.in" />
            </Helmet>

            <Container maxWidth="xs" sx={{ py: 2 }}>
                <Box
                    component={"div"}
                    sx={{
                        display: "flex",
                        mb: 4
                    }}
                >
                    <IconButton
                        sx={{
                            backgroundColor: "secondary.main",
                            p: 0.8,
                            borderRadius: 1,
                            width: 30,
                            height: 30,
                            "&:hover": {
                                backgroundColor: "secondary.main",
                                boxShadow: 2,

                            }
                        }}
                        onClick={handleBack}
                    >
                        <KeyboardBackspaceIcon
                            fontSize="large"
                            color="white"
                        />
                    </IconButton>
                </Box>

                <Box
                    component={"div"}
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                    }}>
                    <Box
                        component={'img'}
                        src={Logo99}
                        width={170}
                        sx={{
                            mixBlendMode: "multiply",
                            mx: "auto"
                        }}
                    />
                </Box>

                {pageShow === "/login" && <LoginPage />}
                {pageShow === "/signup" && <SignupPage />}
                {pageShow === "/password-reset" && <PasswordReset />}
            </Container>
        </Container>
    )
}

export default MobileAuthLayout;

